import App from "./components/App";
import ReactDOM from "react-dom";
import "./index.css";

ReactDOM.render(<App/>, document.getElementById("root"));
